import SSOPaymentReportComponent from "features/Report/components/SalaryGroup/SSOPaymentReport";
import useSSOPaymentReport from "features/Report/hooks/salaryGroup/useSSOPaymentReport";

const SSOPaymentReportPage = () => {
    const useSSOPaymentReportProps = useSSOPaymentReport();
    return <SSOPaymentReportComponent {...useSSOPaymentReportProps} />
}

export default SSOPaymentReportPage;